export default __webpack_public_path__ + "scene4_1_bga22f3c.png";